<template>
  <div class="epidemic-over-view">

      <div class="epidemic-over-view-line" style="margin: 40px 0;padding: 0 40px;">
        <div class="epidemic-person-count-box">
          <div class="epidemic-person-count">{{registerCount}}</div>
          <div class="epidemic-person-tip">已登记人数</div>
        </div>
        <div class="epidemic-person-count-box">
          <div class="epidemic-person-count">{{tempratureCount}}</div>
          <div class="epidemic-person-tip">累计测温人数</div>
        </div>
        <div class="epidemic-person-count-box" style="background-color: #FFC000;">
          <div class="epidemic-person-count">{{abnormalTotalCount}}</div>
          <div class="epidemic-person-tip">累计异常人数</div>
        </div>
        <div class="epidemic-person-count-box" style="background-color: #FFC000;">
          <div class="epidemic-person-count">{{abnormalDayCount}}</div>
          <div class="epidemic-person-tip">当日测温异常人数</div>
        </div>
      </div>

      <div class="epidemic-over-view-line" style="margin: 60px 0 70px 0;">
        <div class="epidemic-over-view-line-left">
          <epidemic-personnel-pie />
        </div>
        <div class="epidemic-over-view-line-right">
          <epidemic-temperature-measurement  />
        </div>
      </div>

      <div class="epidemic-over-view-line" style="height: 270px;display: flex;justify-content: flex-start;flex-direction: column;padding: 10px 10px;border: 1px solid #eeeeee;border-radius: 10px;overflow: hidden;">
          <div style="display: flex;justify-content: space-between">
            <div></div>
            <div style="font-size: 16px;font-weight: 500;">异常人员跟踪 ({{abnormalPeopleTotal}})</div>
            <el-pagination
              @current-change="abnormalPeopleCurrentChange"
              :page-size="abnormalPeoplePageSize"
              layout="prev, pager, next"
              :total="abnormalPeopleTotal">
            </el-pagination>
          </div>
          <el-table
            :data="abnormalPeopleTableData"
            style="width: 100%">
            <el-table-column
              label="姓名">
              <template slot-scope="scope">
                <span>{{ scope.row.personName }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="手机号">
              <template slot-scope="scope">
                <span>{{ scope.row.phone }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="房间号">
              <template slot-scope="scope">
                <span>{{ scope.row.roomInfoName }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="住户名称">
              <template slot-scope="scope">
                <span>{{ scope.row.enterpriseName }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="体温值">
              <template slot-scope="scope">
                <span>{{ scope.row.temprature }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="备注">
              <template slot-scope="scope">
                <span>{{ scope.row.memo || '--' }}</span>
              </template>
            </el-table-column>
          </el-table>
      </div>

  </div>
</template>

<script>
  import {api} from '../../api/epidemicSituation'
  import {errorHandler} from '../../../utils/errorHandler'
  import ControllerPie from '../../../components/Echarts/Pie/Pie/controllerPie'
  import AmmeterPie from '../../../components/Echarts/Pie/Pie/ammeterPie'
  import epidemicPersonnelPie from '../../../components/Echarts/Pie/Pie/epidemicPersonnelPie'
  import EpidemicTemperatureMeasurement from '../../../components/Echarts/Line/EpidemicTemperatureMeasurement'
  import ElectronicStackingBar from '../../../components/Echarts/Bar/StackingBar/ElectronicStackingBar'
  import ElectronicMonthStackingBar from '../../../components/Echarts/Bar/StackingBar/ElectronicMonthStackingBar'

  export default {
    components: {
      ElectronicMonthStackingBar,
      ElectronicStackingBar,
      AmmeterPie,
      ControllerPie,
      epidemicPersonnelPie,
      EpidemicTemperatureMeasurement
    },
    name: 'epidemic-over-view',
    data () {
      return {
        // 人数统计
        registerCount: 0,
        tempratureCount: 0,
        abnormalTotalCount: 0,
        abnormalDayCount: 0,

        // 异常人员表
        abnormalPeoplePageNum: 1,
        abnormalPeoplePageSize: 5,
        abnormalPeopleTotal: 0,
        abnormalPeopleTableData: []
      }
    },
    created () {
    //   this.getBuildingList()
      this.personCount()
      this.abnormalCountPage()
    },
    methods: {
      // 获取数据
      personCount () {
        this.$axios.post(api.personCount, {})
          .then(res => {
            if (res.data.retCode === 1) {
              let data = res.data.data
              this.registerCount = data.registerCount
              this.tempratureCount = data.tempratureCount
              this.abnormalTotalCount = data.abnormalTotalCount
              this.abnormalDayCount = data.abnormalDayCount
            }
          })
          .catch(errorHandler('获取失败'))
      },

      // 异常人员
      abnormalPeopleCurrentChange (val) {
        this.abnormalPeoplePageNum = val
        this.abnormalCountPage()
      },

      // 获取异常人员
      abnormalCountPage () {
        this.$axios.post(api.abnormalCountPage, {
          enterpriseType: '1',
          pageNum: this.abnormalPeoplePageNum,
          pageSize: this.abnormalPeoplePageSize
        })
          .then(res => {
            if (res.data.retCode === 1) {
              let data = res.data.data
              this.abnormalPeopleTableData = data.list
              this.abnormalPeopleTotal = data.total
            }
          })
          .catch(errorHandler('获取异常人员失败'))
      },

      // 跳转防疫登记页面
      toEpidemicSituationRegisterPage (data) {
        this.$router.push({
          name: `epidemic-situation-register`,
          params: {
            id: data
          }
        })
      },

      // 跳转体温监测页面
      toTemperaturePage (data) {
        this.$router.push({
          name: `/temperature`,
          params: {
            id: data
          }
        })
      }

    }
  }
</script>

<style lang="less">
  .epidemic-over-view {
    padding: 10px 2%;
    .epidemic-over-view-line {
      display: flex;
      justify-content: space-between;
      .epidemic-person-count-box {
        width: 200px;
        height: 80px;
        padding: 10px 10px;
        border-radius: 10px;
        color: #ffffff;
        background-color: #00A0E6;
        display: flex;
        justify-content: space-between;
        flex-direction: column;
        .epidemic-person-count {
          font-size: 32px;
          font-weight: 500;
        }
        .epidemic-person-tip {
          font-size: 14px;
        }
      }
      .epidemic-over-view-line-left {
        width: 49%;
        padding: 10px 10px;
        border: 1px solid #eeeeee;
        border-radius: 10px;
        display: flex;
        justify-content: space-between;
        overflow: hidden;
      }
      .epidemic-over-view-line-right {
        width: 49%;
        padding: 10px 10px;
        border: 1px solid #eeeeee;
        border-radius: 10px;
        overflow: hidden;
      }

      .el-table {
        thead {
          th {
            padding: 6px 0;
            text-align: center;
            color: #666666;
            background-color: #eff1f5;
          }
        }
        tbody {
          td {
            padding: 6px 0;
            text-align: center;
            color: #FF0000;
          }
        }
      }

      .el-pagination {
        padding: 0;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/EpidemicSituation/EpidemicOverView/EpidemicOverView.vue